import {createReducer, SerializedError} from '@reduxjs/toolkit'
import {getSchedule, getScheduleData} from '../actions/schedule'
import {setLocation, resetFilter, toggleTag, setFilter} from '../actions/filter'

const initialState: SerializedError = null

export const error = createReducer(initialState, builder => {
  builder
    .addCase(getSchedule.rejected, (state, action) => action.error)
    .addCase(getScheduleData.rejected, (state, action) => action.error)
    .addCase(setLocation.rejected, (state, action) => action.error)
    .addCase(resetFilter.rejected, (state, action) => action.error)
    .addCase(toggleTag.rejected, (state, action) => action.error)
    .addCase(setFilter.rejected, (state, action) => action.error)
})
